import * as React from "react"
import { Container, Row } from "react-grid-system"
import Card from "../../atoms/Card"
import Subtitle from "../../atoms/typography/Subtitle"
import { HorizontalSpacer } from "../../atoms/spacers"
import BodyLarge from "../../atoms/typography/BodyLarge"
import { Link } from "react-router-dom"
import ColorfulButton from "../../atoms/buttons/ColorfulButton"
import { CheckCircleIcon } from "../../atoms/icons/CheckCircleIcon"

const ActivateLoginPage: React.FC = () => {
  React.useEffect(() => {
    document.title = "Thank you for registering"
  }, [])

  return (
    <div style={{ backgroundColor: "#D5E2EAe1", minHeight: "100vh" }}>
      <HorizontalSpacer spacing={3} />
      <Container>
        <Card>
          <HorizontalSpacer spacing={1} />
          <Row justify="center">
            <CheckCircleIcon />
          </Row>
          <HorizontalSpacer spacing={2} />
          <Row justify="center">
            <Subtitle>Your account has been successfully activated!</Subtitle>
          </Row>
          <HorizontalSpacer spacing={3} />
          <Row justify="center">
            <BodyLarge textAlign="center">Thank you for registering and welcome to Satcube.com!</BodyLarge>
          </Row>
          <HorizontalSpacer spacing={3} />
          <Row justify="center">
            <Link to="/login">
              <ColorfulButton title="Log in" variant="green" />
            </Link>
          </Row>
          <HorizontalSpacer spacing={2} />
        </Card>
      </Container>
      <HorizontalSpacer spacing={3} />
    </div>
  )
}

export default ActivateLoginPage
